import React from 'react';

import { navigateTo } from '../../contrib/Utils/navigateTo';
import { externalRoutes } from '../../routes/Utils/Routes/external.routes';
import { Button } from '../Button/Button';
import { darkWaglLogo } from '../../assets/images';
import { FooterStyled } from './FooterStyled';

const Footer = () => {
  const termsTo = externalRoutes.privacyPolicy;
  const policyTo = externalRoutes.termsOfService;

  return (
    <FooterStyled>
      <div className="inner-wrapper">
        <div className="footer-admin-content">
          <div className="logo">
            <div className="line" />

            <img src={darkWaglLogo} width="120px" alt="wagl logo" />

            <div className="line" />
          </div>

          <div className="buttons">
            <Button
              classes={{ root: 'footer-button' }}
              variant="text"
              onClick={navigateTo(termsTo)}
            >
              TERMS OF SERVICE
            </Button>

            <Button
              classes={{ root: 'footer-button' }}
              variant="text"
              onClick={navigateTo(policyTo)}
            >
              PRIVACY POLICY
            </Button>
          </div>
        </div>

        <div className="copyright">Copyright WAGL, All Rights Reserved</div>
      </div>
    </FooterStyled>
  );
};

export default Footer;
